import type { App, AppResearchContext } from '../types/app';

type AppContextInput =
  | App
  | {
      name?: string;
      description?: string;
      category?: string;
      platform?: 'android' | 'ios' | 'both' | string;
      storeUrl?: string;
      androidStoreUrl?: string;
      iosStoreUrl?: string;
      researchContext?: AppResearchContext;
    };

const toList = (value: unknown): string =>
  Array.isArray(value)
    ? value
        .map((item) => String(item || '').trim())
        .filter(Boolean)
        .join(', ')
    : '';

export function buildAppContextLines(app: AppContextInput): string[] {
  const context = app?.researchContext;
  return [
    `App name: ${app?.name || 'N/A'}`,
    `App category: ${app?.category || 'N/A'}`,
    `App platform coverage: ${app?.platform || 'N/A'}`,
    `App description: ${app?.description || 'N/A'}`,
    `Store URL: ${app?.storeUrl || 'N/A'}`,
    `Android URL: ${app?.androidStoreUrl || 'N/A'}`,
    `iOS URL: ${app?.iosStoreUrl || 'N/A'}`,
    `Research summary: ${context?.summary || 'N/A'}`,
    `Launch date: ${context?.appLaunchDate || 'N/A'}`,
    `Rating: ${context?.rating || 'N/A'}`,
    `Downloads estimate: ${context?.downloadsEstimate || 'N/A'}`,
    `What it does: ${context?.whatItDoes || 'N/A'}`,
    `Target demographics: ${toList(context?.targetDemographics) || 'N/A'}`,
    `Monetization: ${toList(context?.monetization) || 'N/A'}`,
    `Key features: ${toList(context?.keyFeatures) || 'N/A'}`,
    `Growth signals: ${toList(context?.growthSignals) || 'N/A'}`,
    `Opportunities: ${toList(context?.opportunities) || 'N/A'}`,
    `Risks: ${toList(context?.risks) || 'N/A'}`,
    `Strategic recommendations: ${toList(context?.strategicRecommendations) || 'N/A'}`,
  ];
}
